import { signal } from "@preact/signals-react";

export const couponsType = signal(null);
export const couponsData = signal(null);
export const PropCouponTypeData = signal("");
export const PropCouponColor = signal("");
export const CommissionsPolicy = signal(null);

export async function sendOTP(phone, otp) {
  const url = "https://graph.facebook.com/v18.0/303762926162057/messages";
  const bearerToken =
    "EAAFWxNCBfUoBO0sW6rhYrFnlccO5Kap99P8foGP3X6xLm7nDUk8cFZCZB4oQfOvLNZCXCGZChgSubNHHi5bzACawNwFzSaSAQi9BjBvAVAYpy3ycSf4RMcgAojqeoCulb6lhMbtMHW566Bmzd9kfSJOE4HzJZCSIooVfWVJqRp28aaAWJVRA5Of7nttrfTfZA5";
  const payload = {
    messaging_product: "whatsapp",
    to: phone,
    type: "template",
    template: {
      name: "b2bappotp",
      language: { code: "en" },
      components: [
        {
          type: "body",
          parameters: [
            {
              type: "text",
              text: otp,
            },
          ],
        },
        {
          type: "button",
          sub_type: "url",
          index: 0,
          parameters: [
            {
              type: "text",
              text: otp,
            },
          ],
        },
      ],
    },
  };

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending OTP:", error);
  }
}
